import api from './axiosApi'
import type { UndoResult, UndoStackResponse } from './planUndo'

/**
 * Fetch the current user's undoable line-item changes for this version.
 * GET /plans/{plan_id}/versions/{version_id}/table/undo-stack
 */
export async function fetchTableUndoStack(
  planId: string,
  versionId: string
): Promise<UndoStackResponse> {
  const response = await api.get<UndoStackResponse>(
    `/plans/${planId}/versions/${versionId}/table/undo-stack`
  )
  return response.data
}

/**
 * Undo the current user's most recent line-item change (cell edit, bulk
 * edit, or import) for this version.
 * POST /plans/{plan_id}/versions/{version_id}/table/undo
 */
export async function undoTableChange(
  planId: string,
  versionId: string
): Promise<UndoResult> {
  const response = await api.post<UndoResult>(
    `/plans/${planId}/versions/${versionId}/table/undo`
  )
  return response.data
}
